'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalShodoSignResponse(certchain, assinaturas) {
  this.WM = null;
  this.WL = null;
  this.WM = certchain;
  this.WL = assinaturas;
}
export { $c_Lpresto_AgentView$LocalShodoSignResponse as $c_Lpresto_AgentView$LocalShodoSignResponse };
$p = $c_Lpresto_AgentView$LocalShodoSignResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalShodoSignResponse;
/** @constructor */
function $h_Lpresto_AgentView$LocalShodoSignResponse() {
}
export { $h_Lpresto_AgentView$LocalShodoSignResponse as $h_Lpresto_AgentView$LocalShodoSignResponse };
$h_Lpresto_AgentView$LocalShodoSignResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AgentView$LocalShodoSignResponse)) {
    if ((this.WM === x$0.WM)) {
      var x = this.WL;
      var x$2 = x$0.WL;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "LocalShodoSignResponse";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.WM;
  }
  if ((n === 1)) {
    return this.WL;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_AgentView$LocalShodoSignResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hK)));
}
export { $isArrayOf_Lpresto_AgentView$LocalShodoSignResponse as $isArrayOf_Lpresto_AgentView$LocalShodoSignResponse };
var $d_Lpresto_AgentView$LocalShodoSignResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalShodoSignResponse, "presto.AgentView$LocalShodoSignResponse", ({
  hK: 1,
  bv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalShodoSignResponse as $d_Lpresto_AgentView$LocalShodoSignResponse };
//# sourceMappingURL=presto.-Agent-View$-Local-Shodo-Sign-Response.js.map
